// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gt-table-content{z-index:5;position:absolute;top:0;height:100%;overflow:auto;width:100%;background:#fff}.gt-table-content .gt-table-row-wrap{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex}.gt-table-content-out{position:relative}", ""]);
// Exports
module.exports = exports;
